import React, { Component } from 'react';
import axios from 'axios';
import { Loader, Segment } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import NonCycleStudentPersonalInformationForm from './NonCycleStudentPersonalInformationForm';
import NonCycleStudentCompletionDetailsForm from './NonCycleStudentCompletionDetailsForm';
import NonCycleStudentProgramInformationForm from './NonCycleStudentProgramInformationForm';
import { nonCycleStudentToBodyMapper, validateNonCycleStudent } from './NonCycleStudentInputForm';

class NonCycleStudentEditWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saving: false,
            student: props.student,
            errors: {},
            originalStudent: props.student,
            personalInformation: props.personalInformation,
            studyProgramInformation: props.studyProgramInformation,
            completionDetails: props.completionDetails,
        };
    }

    handleChange = (updatedFields) => {
        this.setState((prevState) => ({
            student: {
                ...prevState.student,
                ...updatedFields
            }
        }));
    };

    handleSubmit = (student) => {
        const body = nonCycleStudentToBodyMapper(student);

        const errors = validateNonCycleStudent(student);
        this.setState({ errors });

        if (Object.values(errors)
            .some((err) => err)) {
            console.log(errors);
            toast(<FormattedMessage id="externalStudent.toast.fillRequiredFields"/>);
            return;
        }

        this.setState({ saving: true });

        axios.put(`/non-cycle-student/`, body)
            .then((res) => {
                this.setState({ saving: false });
                this.props.onEdit(student);
                this.props.onCancel();
                toast(<FormattedMessage id="externalStudent.toast.editSuccess"/>);
            })
            .catch((err) => {
                this.setState({ saving: false });
                toast(<FormattedMessage id="externalStudent.toast.editError"/>);
            });
    };

    render() {
        const {
            saving,
            student,
            errors,
            personalInformation,
            studyProgramInformation,
            completionDetails,
        } = this.state;

        if (saving) {
            return <div style={{
                paddingTop: '100px',
                paddingBottom: '100px'
            }}><Loader active inline="centered"/></div>;
        }

        if (personalInformation) {
            return <NonCycleStudentPersonalInformationForm student={student} errors={errors} edit
                                                           onCancel={this.props.onCancel}
                                                           onSave={this.handleSubmit}
                                                           onChangeStudent={this.handleChange}
            />;
        }

        if (studyProgramInformation) {
            return <NonCycleStudentProgramInformationForm student={student} errors={errors} edit
                                                          onCancel={this.props.onCancel}
                                                          onSave={this.handleSubmit}
                                                          onChangeStudent={this.handleChange}
            />;
        }

        if (completionDetails) {
            return <NonCycleStudentCompletionDetailsForm student={student} errors={errors} edit
                                                         onCancel={this.props.onCancel}
                                                         onSave={this.handleSubmit}
                                                         onChangeStudent={this.handleChange}
            />;
        }

        return <Segment></Segment>;
    }
}

export default NonCycleStudentEditWrapper;



// WEBPACK FOOTER //
// ./src/views/NonCycleStudent/NonCycleStudentForms/NonCycleStudentEditWrapper.js